import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { useContractRefundPaymentItemProvider } from '../Finance.ContractRefundPaymentItem.Hooks';

const FinanceContractRefundPaymentItemExclude = () => {
  const { lang } = getLocales();
  const { excludeItem, selected, pageRouter } = useContractRefundPaymentItemProvider();

  if (!selected) return null;

  return (
    <Confirm
      data={selected}
      onConfirm={() => excludeItem(selected)}
      onClose={pageRouter.updateParams}
      actionName={lang.exclude}
      itemName={`(ID: ${selected.id})`}
      info={
        <div style={{ fontSize: Theme.FontSize.M }}>
          <p>{lang.areYouSureYouWantToExcludeThisPaymentItem}</p>
        </div>
      }
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
};

export default FinanceContractRefundPaymentItemExclude;
